import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Box,
  IconButton,
  Link,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { TypographyNormal } from "../customComponent";
import { ViewerBlueIcon } from "../../icons";
import { formattedDate } from "../../helpers/dateFormat";
import { colorStyling } from "../../helpers/color";
// import ViewerScreenshot from "./id/ViewerScreenshot";
import Role from "../../helpers/roles";
import { red } from "@mui/material/colors";
import DialogViewerDelete from "./DialogViewerDelete";
import { SET_VIEWER_DETAIL } from "../../store/actionTypes/viewerActionTypes";

import ViewerStatusIndicator from "./ViewerStatusIndicator";

const ViewerItem = ({ viewer, dispatch, index, userRole }) => {
  const navigate = useNavigate();
  const { viewer: detail } = useSelector((state) => state.viewer);

  const redirectToViewerDetailPage = (id) => {
    const newDetail = {
      ...viewer,
      ...(detail.id === viewer.id && {
        screenGroups: detail.screenGroups,
        schedules: detail.schedules,
      }),
    };
    dispatch({ type: SET_VIEWER_DETAIL, payload: newDetail });
    navigate("/viewer/detail/" + id);
  };

  const viewerNameComponent = (
    <Tooltip
      title={viewer?.name?.length > 30 ? viewer?.name : ""}
      placement="top-start"
    >
      <TypographyNormal
        sx={
          userRole === Role.Eins
            ? { fontWeight: 600 }
            : {
                fontWeight: 600,
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline",
                  color: colorStyling.primary,
                },
              }
        }
      >
        {viewer?.name?.length > 30
          ? viewer?.name?.substring(0, 27).trim() + "..."
          : viewer?.name}
      </TypographyNormal>
    </Tooltip>
  );

  return (
    <TableRow
      key={viewer.name + viewer.id}
      onClick={() => redirectToViewerDetailPage(viewer.id)}
      sx={{
        cursor: "pointer",
        backgroundColor:
          (index + 1) % 2 !== 0
            ? colorStyling.white.hover
            : colorStyling.white.full,
        "&:hover": {
          backgroundColor: colorStyling.white.lightblue,
        },
      }}
    >
      <TableCell sx={{ pl: 3, pr: 0 }}>
        <ViewerBlueIcon />
      </TableCell>
      <TableCell>
        <Box display="flex" alignItems="center">
          {userRole === Role.Eins ? (
            viewerNameComponent
          ) : (
            <Link style={{ textDecoration: "none" }}>
              {viewerNameComponent}
            </Link>
          )}

          {/* TODO: Will work on it when working on the feature */}
          {/* <ViewerScreenshot viewer={viewer} size="sm" /> */}

          {/* {userRole !== Role.User && (
          <BlockViewer viewer={viewer} size="sm" />
        )} */}
        </Box>
      </TableCell>
      <TableCell>
        <Tooltip
          title={viewer?.location?.length > 20 ? viewer?.location : ""}
          placement="top-start"
        >
          <TypographyNormal sx={{ fontWeight: 600 }}>
            {viewer?.location?.length > 20
              ? viewer?.location?.substring(0, 19).trim() + "..."
              : viewer?.location === null
              ? "-"
              : viewer?.location}
          </TypographyNormal>
        </Tooltip>

        {viewer?.locationDesc !== null && viewer?.location !== null && (
          <Tooltip
            title={
              viewer?.locationDesc?.length > 20 ? viewer?.locationDesc : ""
            }
            placement="top"
          >
            <TypographyNormal
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: 600,
                maxWidth: "200px",
              }}
            >
              {viewer?.locationDesc?.length > 20
                ? viewer?.locationDesc?.substring(0, 19).trim() + "..."
                : viewer?.locationDesc === null
                ? "-"
                : viewer?.locationDesc}
            </TypographyNormal>
          </Tooltip>
        )}
      </TableCell>
      <TableCell align="center">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: 1,
          }}
        >
          <ViewerStatusIndicator size={22} viewer={viewer} />
        </Box>
      </TableCell>
      <TableCell>{viewer?.status?.version ?? "-"}</TableCell>
      <TableCell>
        {viewer.activeAt ? formattedDate(viewer.activeAt) : "-"}
      </TableCell>
      {userRole === Role.Eins && (
        <TableCell>
          <ViewerItemMenu viewer={viewer} />
        </TableCell>
      )}
    </TableRow>
  );
};

const ViewerItemMenu = ({ viewer }) => {
  const { t } = useTranslation("viewer");

  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDeleteViewer, setOpenDeleteViewer] = useState(false);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
    setOpenMenu(false);
  };

  const handleOpenDeleteViewer = (event) => {
    event.stopPropagation();
    setOpenDeleteViewer(true);
  };
  const handleCloseDeleteViewer = (event) => {
    event.stopPropagation();
    setOpenDeleteViewer(false);
  };

  return (
    <>
      <IconButton
        sx={{ color: colorStyling.black }}
        aria-controls={openMenu ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          sx={{ color: red[600] }}
          onClick={handleOpenDeleteViewer}
          dense
        >
          <DeleteOutlinedIcon fontSize="small" sx={{ mr: "5px" }} />
          {t("item.deleteBtn")}
        </MenuItem>
        <DialogViewerDelete
          open={openDeleteViewer}
          handleClose={handleCloseDeleteViewer}
          viewer={viewer}
        />
      </Menu>
    </>
  );
};

export default ViewerItem;
